import { createContext } from 'react';
import { State } from '../types/reducer/State';

export const StateContext = createContext<State | undefined>(undefined);
